import React from 'react'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Button from 'js/components/Button/Button'
import Flexer from 'js/components/Flexer/Flexer'
import { H5 } from 'js/components/Heading'

import CustomFieldOption from './CustomFieldOption'

const CustomFieldOptions = ({ id, index, field, enableEditOptions }) => {
    const { t } = useTranslation()

    const { control, setValue } = useFormContext()

    const { guid, fieldOptions } = field

    const handleAddOption = () => {
        setValue(`formFields.${index}.fieldOptions`, [...fieldOptions, ''])
    }

    const handleRemoveOption = (optionIndex) => {
        const optionsCopy = [...fieldOptions]
        optionsCopy.splice(optionIndex, 1)
        setValue(`formFields.${index}.fieldOptions`, optionsCopy)
    }

    const onDragEnd = (result) => {
        if (!result.destination) return

        const sourcePosition = result.source.index
        const destinationPosition = result.destination.index

        const newOptions = [...fieldOptions]
        const [movedOption] = newOptions.splice(sourcePosition, 1)
        newOptions.splice(destinationPosition, 0, movedOption)

        setValue(`formFields.${index}.fieldOptions`, newOptions)
    }

    const buttonProps = {
        type: 'button',
        size: 'large',
        variant: 'secondary',
        hoverSize: 'normal',
        radiusStyle: 'rounded',
    }

    const canEditOptions = enableEditOptions || !guid

    return (
        <>
            <H5 style={{ margin: '20px 0 8px' }}>
                {t('entity-event.options', {
                    count: fieldOptions.length,
                })}
            </H5>
            {canEditOptions ? (
                <>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable
                            droppableId={`attendance-form-field-${index}-options`}
                        >
                            {(provided) => (
                                <ul
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {fieldOptions.map((value, optionIndex) => {
                                        const optionId = `${id}-${optionIndex}`
                                        return (
                                            <CustomFieldOption
                                                key={optionId}
                                                id={optionId}
                                                fieldIndex={index}
                                                index={optionIndex}
                                                control={control}
                                                value={value}
                                                buttonProps={buttonProps}
                                                onRemove={handleRemoveOption}
                                            />
                                        )
                                    })}
                                    {provided.placeholder}
                                </ul>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <Flexer justifyContent="flex-start">
                        <Button
                            variant="tertiary"
                            size="normal"
                            onClick={handleAddOption}
                            style={{
                                marginLeft: '40px',
                            }}
                        >
                            {t('form.add-option')}
                        </Button>
                    </Flexer>
                </>
            ) : (
                <ul>
                    {fieldOptions.map((option, index) => (
                        <li key={index}>{option}</li>
                    ))}
                </ul>
            )}
        </>
    )
}

export default CustomFieldOptions
